import { render, staticRenderFns } from "./detailedInformation.vue?vue&type=template&id=58167231&scoped=true&"
import script from "./detailedInformation.vue?vue&type=script&lang=js&"
export * from "./detailedInformation.vue?vue&type=script&lang=js&"
import style0 from "./detailedInformation.vue?vue&type=style&index=0&id=58167231&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58167231",
  null
  
)

export default component.exports